const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// Format an ISO yyyy-mm-dd as "May 26, 2026" without going through Date(), so
// the prerendered HTML and the hydrating client print the same day whatever
// the visitor's timezone (new Date('2026-05-26') is UTC midnight, which renders
// as May 25 west of Greenwich).
export const formatIsoDate = (iso: string): string => {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};
